import {
	ChangeDetectionStrategy,
	Component,
	ContentChild, ElementRef,
	EventEmitter,
	Input, OnInit,
	Output, TemplateRef, ViewChild,
} from "@angular/core";
import {TabStripItemTemplateDirective} from "./tab.strip.item.template.directive";

// if smaller than min width - edit button will not appear on tab hover
const MIN_EDIT_TAB_WIDTH: number = 60;

@Component({
	selector: 'cp-tab-strip',
	templateUrl: './tab.strip.component.template.html',
	styleUrls: ['./tab.strip.component.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabStripComponent implements OnInit{
	@Input() items: any[];
	@Input() activeItem: any;
	@Input() canAddTabs: boolean = false;
	@Input() canRemoveTabs: boolean = false;
	@Input() canEditTabs: boolean = false;
	@Input() editedItem: any;

	@Output() itemClick: EventEmitter<any> = new EventEmitter<any>();
	@Output() addItemClick: EventEmitter<any> = new EventEmitter<any>();
	@Output() removeItemClick: EventEmitter<any> = new EventEmitter<any>();
	@Output() editTabClick: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('resizeSensor', {static:false,read: ElementRef}) resizeSensor: ElementRef;
	@ViewChild('addTabIcon',{static:false}) addIcon: ElementRef;
	@ContentChild(TabStripItemTemplateDirective, {static:false,read: TemplateRef}) tabItemTemplate;

	public hoveredItem: any = null;
	public showEditIcon: boolean;

	public ngOnInit() {
		this.showEditIcon = this.canEditTabs;
	}

	public trackByIndex(index, item) {
		return index;
	}

	public onTabItemClick(item: any) {
		this.itemClick.emit(item);
	}

	public onEditItemClick(event, item) {
		event.stopPropagation();
		const editIconElementRef = new ElementRef(event.target);
		this.editTabClick.emit({item: item, ref: editIconElementRef});
	}

	public onAddItemClick() {
		this.addItemClick.emit( {addIconRef: this.addIcon });
	}

	onTabMouseLeave() {
		this.hoveredItem = null;
	}

	onTabMouseEnter(item:any, event: any) {
		this.hoveredItem = item;
		this.showEditIcon = this.canEditTabs && event.currentTarget.offsetWidth > MIN_EDIT_TAB_WIDTH;
	}
}
